/* eslint-disable camelcase */
import React from 'react';
import { Accordion, Button, Col, Form, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

import { Formik } from 'formik';
import * as Yup from 'yup';

import DefaultSpinner from '@components/Loader/Loader';
import {
  RoutingAccordion,
  ShadowRoutingAccordion,
  TrunkAccordion,
} from '@components/Numbers/Details/Accordion';
import {
  handleSubmitAddRouting,
  handleSubmitShadowRouting,
  handleSubmitTrunk,
  handleSubmitUpdateRouting,
} from '@components/Numbers/Details/Form/Routing/handlers';
import {
  configureRoutingQueries,
  configureShadowRoutingQueries,
} from '@components/Numbers/Details/configureQuery';
import { numberApi } from '@reducers/number/number';

export const Routing = ({ did, customerTrunk }) => {
  let defaultActiveKey;
  const schema = Yup.object({
    customerTrunk: Yup.number().required(),
    shadowRoutingNumber: Yup.string().optional(),
  });
  const { state } = useLocation();
  if (state && state.activeKey) {
    defaultActiveKey = state.activeKey;
  }
  const numberRouting = configureRoutingQueries({ did });
  const shadowNumberRouting = configureShadowRoutingQueries({ did });
  const [updateNumber] = numberApi.useUpdateDetailsMutation();

  const isUpdating =
    shadowNumberRouting.add.result.isLoading ||
    shadowNumberRouting.update.result.isLoading ||
    shadowNumberRouting.delete.result.isLoading;
  const initialValues = {
    customerTrunk,
    shadowRoutingNumber: shadowNumberRouting.get.query.data?.number || '',
    routingNumber: numberRouting.get.query.data
      ? Object.fromEntries(
          numberRouting.get.query.data.map(({ id, nature, number_out }) => [
            id,
            { originatingNetwork: nature.id, routingNumber: number_out },
          ])
        )
      : {},
    addRoutingNumber: {},
  };
  const onSubmit = async (values) => {
    handleSubmitShadowRouting({
      value: values.shadowRoutingNumber,
      queryManager: shadowNumberRouting,
      did,
    });
    handleSubmitUpdateRouting({
      value: values.routingNumber,
      initialValue: initialValues.routingNumber,
      queryManager: numberRouting,
      did,
    });
    handleSubmitAddRouting({
      value: values.addRoutingNumber,
      queryManager: numberRouting,
      did,
    });
    handleSubmitTrunk({
      value: values.customerTrunk,
      initialValue: initialValues.customerTrunk,
      queryManager: updateNumber,
      did,
    });
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={schema}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, dirty }) => (
        <Form onSubmit={handleSubmit}>
          <Accordion defaultActiveKey={defaultActiveKey}>
            <Accordion.Item eventKey="trunk">
              <TrunkAccordion />
            </Accordion.Item>
            <Accordion.Item eventKey="routing">
              <RoutingAccordion
                did={did}
                getQuery={numberRouting.get.query}
                deleteQuery={numberRouting.delete.query}
              />
            </Accordion.Item>
            <Accordion.Item eventKey="shadowRouting">
              <ShadowRoutingAccordion
                did={did}
                getQuery={shadowNumberRouting.get.query}
                deleteQuery={shadowNumberRouting.delete.query}
              />
            </Accordion.Item>
          </Accordion>
          <Row>
            <Col className="text-end mt-3" md={12}>
              <Button
                variant="didxl"
                onClick={!dirty ? null : handleSubmit}
                disabled={isUpdating || !dirty}
              >
                {isUpdating ? <DefaultSpinner /> : 'Save'}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};
